import React from "react";

import TheFalls from "../../ByLaws/Green Oak Twp/The Falls II of Hidden Lake By-Laws/The-Falls-II-of-Hidden-Lake-By-Laws.pdf";


export default function GreenOak () {

    return(
        <div>
           <a style={{color: 'black', display: 'flex', margin: '2%'}}href={TheFalls}>The Falls II of Hidden Lake ByLaws</a>
        </div>
    )
}